import './Photography.css'
import React, { Component } from 'react'
import p1 from '../../assets/photography/1.jpg'
import p2 from '../../assets/photography/2.jpg'
import p3 from '../../assets/photography/3.jpg'
import p4 from '../../assets/photography/4.jpg'
import p5 from '../../assets/photography/5.jpg'
import p6 from '../../assets/photography/6.jpeg'
import p7 from '../../assets/photography/7.jpeg'
import p8 from '../../assets/photography/8.jpeg'
import p9 from '../../assets/photography/9.jpeg'
import p10 from '../../assets/photography/10.jpeg'

const photoGraphyList = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10]

const PhotoList = photoGraphyList =>
	photoGraphyList.map((img, i) => (
		<li className="Photography-Item">
			<img src={img} alt={i} className="Photography-Image" />
		</li>
	))

class Photography extends Component {
	componentDidMount() {
		document.title = 'Photography'
	}
	render() {
		return (
			<div className="Photography">
				<ul className="PhotographyList">{PhotoList(photoGraphyList)}</ul>
			</div>
		)
	}
}

export default Photography



// WEBPACK FOOTER //
// ./src/components/Photography/Photography.js